// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__3SBgk","Pagination":"Layout_Pagination__U_jJw"};